module.exports = __webpack_public_path__ + "static/media/BG.adda1e0a.png";